<template>
    <div class="page-wrapper">
        <div class="page-title">
            <CIcon name="cil-list" /> Existing Cases
            <span class="page-title-badge" v-if="totalRows > 0">{{ totalRows }} records</span>
        </div>

        <CRow>
            <CCol md="12" class="pad-r-0 pad-l-0">
                <data-filter
                    :tableLength="filteredTableLength"
                    v-model="filter"
                    :existing="true"
                ></data-filter>
            </CCol>
        </CRow>
        <div v-if="loading" class="loader-area">
            <pulse-loader :loading="loading" color="#2E7D32"></pulse-loader>
        </div>
        <CRow>            
            <CCol md="12" class="pad-r-0 pad-l-0">
                <CCard>
                    <CCardHeader class="no-backdrop">
                        <div class="d-flex justify-content-between align-items-center w-100">
                            <span class="text-muted">
                                Sorting By: <strong>{{ fieldKeys[sortBy] }}</strong>, 
                                <strong>{{ sortDesc ? 'Descending' : 'Ascending' }} order</strong>
                            </span>
                            <json-excel v-if="download.length > 0"
                                :data = "download"
                                :name = "filename"
                            >
                                <CButton color="success" size="sm">
                                    <CIcon name="cil-cloud-download" /> Export Excel
                                </CButton>
                            </json-excel>
                        </div>
                    </CCardHeader>
                    <CCardBody >
                        <b-table 
                            hover
                            selectable
                            :responsive="true"
                            select-mode="single"
                            @row-selected="onSelectRow"
                            :items="filteredItems"
                            :fields="fields"
                            class="clickable-table"
                            id="reportTable"
                            :sort-desc.sync="sortDesc"
                            :sort-by.sync="sortBy"
                            sort-icon-left
                        >
                            <template v-slot:cell(dateOfAdmission)="data">
                                {{data.item.dateOfAdmission.substring(0,10)}} 
                            </template>
                            <template v-slot:cell(dateOfOutcome)="data">
                                {{data.item.dateOfOutcome != null ? data.item.dateOfOutcome.substring(0,10) : 'N/A'}} 
                            </template>
                        </b-table>
                        <b-pagination 
                            align="center"
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            aria-controls="reportTable"
                        ></b-pagination>
                    </CCardBody>
                </CCard>
            </CCol>            
        </CRow>
    </div>
</template>

<script>

import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import axios from 'axios';
import store from '../store';
import JsonExcel from 'vue-json-excel';
import DataFilter from './components/dataFilter.vue';

export default {
    name : 'Reports',
    components: {
        PulseLoader,
        JsonExcel,
        DataFilter
    },
    props : {
        small : true,
        
    },
    data() {
        return {
            baseURL : store.state.baseURL,
            items: [
            ],
            filename : 'SaveAnimals_DB_Existing_Cases.xls',
            selected : {},
            filter : {
                fromDate : null,
                toDate : null,
                class : null,
                family : null,
                group : null,
                identity : null,
                scientific : null,
                zone : null,
                outcome : null,
                timeType : null,
                date : null,
                timeIntervalType : null,
                caseno : null,
                stage : null,
                facility : null,
                placeOfRescue : null,
                causeOfDisp : null
            },
            perPage: 20,
            currentPage: 1,
            totalRows : 0,
            loading : true,
            fieldKeys : {
                'caseNumber' : "Case Number",
                'zoneName' : "Zone Name",
                'animalData.identityName' : "Identity Name",
                'animalData.iucnCategory' : "IUCN Status",
                'displacement' : "Displacement Cause",
                'dateOfAdmission' : "Date of Admission",
                'placeOfRescue' : "Place of Rescue",
                'finalDisposition' : "Outcome",
                'dateOfOutcome' : "Date of Outcome",
            },
            fields : [
                {
                    key : 'caseNumber',
                    label : 'Case No',
                    sortable : true
                },
                {
                    key : 'zoneName',
                    label : "Zone",
                    sortable : true
                },
                {
                    key : 'animalData.identityName',
                    label : 'Identity',
                    sortable : true
                },
                {
                    key : 'animalData.iucnCategory',
                    label : 'IUCN Status',
                    sortable : true
                },
                {
                    key : 'displacement',
                    label : 'Displacement Cause',
                    sortable : true
                },
                {
                    key : 'dateOfAdmission',
                    label : 'Date (Admission)',
                    sortable : true
                },
                {
                    key : 'placeOfRescue',
                    label : 'Place of Rescue',
                    sortable : true
                },
                {
                    key : 'finalDisposition',
                    label : "Outcome",
                    sortable : true
                },
                {
                    key : 'dateOfOutcome',
                    label : "Date (Outcome)",
                    sortable : true
                },
                {
                    key : 'placeOfOutcome',
                    label : "Place Of Outcome",
                    sortable : true
                },
            ],
            download : [],
            sortDesc: true,
            sortBy: 'dateOfAdmission',
            loadPage : 1,
            pagesAvailable : 1,
        }
    },
    beforeMount(){
        var d = new Date();
        var str = d.toISOString();
        str = str.substr(0, 10);
        str = str.replace(/-/g, '');
        this.filename = 'Completed_Cases_SaveAnimals_DB_'+ str +'.xls';
    },
    created() {
        this.loading = true;
        this.selected = {
            sourceIntervalType : store.state.filters.sourceIntervalType,
            sourceType : store.state.filters.sourceype,
            date : store.state.filters.date,
            startDate : store.state.filters.startDate,
            endDate : store.state.filters.endDate,
            outcome : store.state.filters.outcome,
            zone : store.state.filters.zone,
            class : store.state.filters.class,
            family : store.state.filters.family,
            group : store.state.filters.group,
            identity : store.state.filters.identity,
            caseno : store.state.filters.caseno,
            scientific : store.state.filters.scientific,
            stage : store.state.filters.stage,
            facility : store.state.filters.facility,
            placeOfRescue : store.state.filters.placeOfRescue,
            causeOfDisp : store.state.filters.causeOfDisp,
            approvalStatus: store.state.filters.approvalStatus || [],
            unit: store.state.filters.unit || [],
            role: store.state.filters.role || [],
            month : store.state.filters.month,
            year : store.state.filters.year,
        }

        this.filter = {
            fromDate : this.selected.startDate,
            toDate : this.selected.endDate,
            class : this.selected.class,
            family: this.selected.family,
            group : this.selected.group,
            identity : this.selected.identity,
            scientific : this.selected.scientific,
            zone : this.selected.zone,
            outcome : this.selected.outcome,
            timeType : this.selected.sourceType,
            date : this.selected.date,
            timeIntervalType : this.selected.sourceIntervalType,
            caseno : this.selected.caseno,
            stage : this.selected.stage,
            facility : this.selected.facility,
            placeOfRescue : this.selected.placeOfRescue,
            causeOfDisp : this.selected.causeOfDisp,
            approvalStatus : this.selected.approvalStatus,
            unit : this.selected.unit,
            role : this.selected.role
        }
        // this.getRecords(true);
    },
    computed: {
        filteredItems() {
            // If filtering by second admission, only show records that have a dateOfSecondAdmission
            if (this.filter.timeType === 'second_admission') {
                return this.items.filter(item => 
                    item.dateOfSecondAdmission && 
                    item.dateOfSecondAdmission !== null && 
                    item.dateOfSecondAdmission !== ''
                );
            }
            // Otherwise, return all items
            return this.items;
        },
        filteredTableLength() {
            // Return the total count from the API (pagination.total), not just the current page size
            return this.totalRows;
        }
    },
    watch : {
        filter : function(newVal, oldVal){
            this.currentPage = 1;
            this.getRecords(true);
        },
        currentPage : function(newVal, oldVal){
            this.getRecords(true);
        }
    },
    methods: {
        // loadMore(){
        //     ++this.loadPage;
        //     if(this.tableLength == this.items.length){
        //         
        //     }
        //     else{
        // 
        //         this.getRecords(false);
        // 
        //     }
        // 
        // },
        makeDownloadable(records){
            this.download = [];
            for(var x in records){         

                this.download.push({     
                    "Case ID" : records[x].caseNumber,    
                    "Zone" : records[x].zoneName,    
                    "Species" : records[x].animalData.identityName,
                    "Rescue type" : records[x].rescueType,
                    // "Date of rescue/displacement" : records[x].dateOfRescue.substring(0,10),
                    "Date of rescue/displacement" :records[x].dateOfRescue != null? records[x].dateOfRescue.substring(0,10):null,
                    "Place of rescue" : records[x].placeOfRescue,
                    "Coordinates of place of rescue Lat" : records[x].gpsLatitudeRescue,
                    "Coordinates of place of rescue Long" : records[x].gpsLongditudeRescue,
                    "Cause of displacement" : records[x].displacement,
                    // "Details of intervention" : '',
                    "Type of intervention (in situ/ex situ)" : records[x].rescueMode,
                    "First attended by" : records[x].rescuedBy,
                    "Date of admission/intervention" : records[x].dateOfAdmission.substring(0,10),
                    "Stage" : records[x].stage,
                    "Sex" : records[x].sex,
                    "Weight" : records[x].weight,
                    "Length (Approx)" : records[x].length,
                    "Outcome" : records[x].finalDisposition,
                    "Place Of Outcome" : records[x].placeOfOutcome,
                    "Date of outcome" : records[x].dateOfOutcome != null ? records[x].dateOfOutcome.substring(0,10) : null,
                    // "Place of outcome" : records[x].placeOfRelease,
                    "Coordinates of place of release Lat" : records[x].gpsLatRelease,
                    "Coordinates of place of release Long" : records[x].gpsLongRelease,
                    "Remarks" : records[x].remarks,                    
                });
            }

        },   
    
        getRecords(reset){
            this.loading = true;
            axios({
                url : this.baseURL + "records/existing-cases?p="+this.currentPage + "&limit=" + this.perPage,
                headers : {
                    authorization : store.state.token
                },
                data : this.filter,
                method : "POST"
            })
            .then(res => {
                if(res.data.status)
                {              
                    this.items = res.data.data;

                    if (res.data.pagination) {
                        this.totalRows = res.data.pagination.total;
                        this.pagesAvailable = res.data.pagination.totalPages;
                    } else {
                        // Fallback if backend structure is different
                        this.totalRows = res.data.count || 0;
                    }

                    this.makeDownloadable(this.items);    
                    
                    if(this.items.length == 0){
                        this.$notify({
                            group: 'notification',
                            type : 'error',
                            title: 'Important message',
                            text: "Zero records found!"
                        });
                    }
                }
                else
                {
                    this.items = []
                    this.totalRows = 0;
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: res.data.message
                    });
                }
                this.loading = false;
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Error in loading data. Something went wrong!'
                });
                console.log(err);
                this.loading = false;
                return [];
            });

        },
        onSelectRow(row){
            this.openReport(row[0]._id);

        },
        selectAnimal(item){
        },
        openReport(id){
            window.open(`/edit-case/${id}`, '_blank');
            // this.$router.push({name : 'Conflict Report', params : { surveyid }});
        }
    }
}
</script>

<style scoped>
    .pad-r-0 {
        padding-right: 0px !important;
    }
    .pad-l-0 {
        padding-left: 0px !important;
    }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



